import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black';
  const variants = {
    primary: 'bg-violet-500 hover:bg-violet-400 text-white focus:ring-violet-400 shadow-[0_4px_14px_0_rgba(139,92,246,0.45)] hover:shadow-[0_6px_20px_rgba(139,92,246,0.55)] hover:-translate-y-0.5',
    secondary: 'bg-purple-700 hover:bg-purple-600 text-white focus:ring-purple-500 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-violet-700 hover:border-violet-400 text-violet-100 hover:bg-violet-950/40 focus:ring-violet-400'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-339">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-340" />}
    </motion.button>;
}